<template>
  <v-card flat>
    <v-row
      v-if="
        computedValue &&
        !Array.isArray(computedValue) && 
        [ 'qr.create.photoGalleryModel',
          'qr.create.photoGalleryedit',
          'modelsList.memories.edit',
          'qr.create.memories',
          'qr.name.editPhoto', 'qr.photo','qr.create.photoGalleryModel', 'qr.name.editPhoto', 'qr.name.id.editPhoto','qr.name.editgift','qr.name.id.editgift','qr.gift'].includes(
          $route?.name.toLowerCase()
        )
      "
      class="mb-4 mx-1 mt-2"
    >
      <v-col cols="12" sm="6">
        <v-select
          v-model="computedValue.mode"
          :items="modeOptions"
          :label="!isGiftRoute?'حالت نمایش هدر':'حالت نمایش تصاویر منتخب'"
          outlined
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <pic-selector
      v-if="computedValue && computedValue.hasOwnProperty('gallery')"
      v-model="computedValue.gallery"
      :edit-name="false"
      :default-cat-name="$t('banner')"
      single
    />

    <pic-selector
      v-else
      v-model="computedValue"
      :edit-name="false"
      :default-cat-name="$t('banner')"
      single
    />
  </v-card>
</template>

<script>
import PicSelector from "./picSelector";
const GIFT_ROUTES = [
  "qr.gift",
  "qr.name.editgift",
  "qr.name.id.editgift",
  "modelsList.memories.edit",
  "qr.create.memories",
];

export default {
  name: "bannerSelector",

  components: { PicSelector },

  props: {
    value: [Object, Array],
  },
  data() {
    return {
      modeOptions: [
        { text: "شبکه‌ای", value: "grid" },
        { text: "اسلایدر", value: "slider" },
      ],
    };
  },
created() {
  const routeNames = [
    "qr.photo",
    "qr.name.editphoto",
    "qr.name.id.editphoto",
    'qr.create.photoGalleryModel',
    'qr.create.photoGalleryedit',

  ];

  if (routeNames.includes(this.$route?.name?.toLowerCase())) {

    if (Array.isArray(this.value)) {
      this.$emit("input", {
        mode: "grid",
        gallery: [...this.value], // clone array
      });

    } else if (
      this.value &&
      typeof this.value === "object" &&
      !this.value.mode
    ) {

      const newValue = {
        ...this.value,
        mode: "grid",
      };

      this.$emit("input", newValue);
    }
  }
},
computed: {
          isGiftRoute() {
      return GIFT_ROUTES.includes(this.$route.name);
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
